export function stripCommentsAndEmptyLinesFromCode(code: string) {
    const reSingleLineComment = /(\/\/.*)/g;
    const reMultiLineComment = /\/\*(.|[\r\n])*?\*\//gm;
    const reEmptyOrBlankLines = /\n+\s*\n/gm;
    return code
        .replace(reMultiLineComment, "")
        .replace(reSingleLineComment, "")
        .replace(reEmptyOrBlankLines, "\n");
}

export function stripSqlCommentsAndEmptyLinesFromCode(code: string) {
    const reSingleLineComment = /(--.*)/g;
    const reMultiLineComment = /\/\*(.|[\r\n])*?\*\//gm;
    const reEmptyOrBlankLines = /\n+\s*\n/gm;
    return code
        .replace(reMultiLineComment, "")
        .replace(reSingleLineComment, "")
        .replace(reEmptyOrBlankLines, "\n");
}


export function* getMatchesFromString(source: string, regex: RegExp) {
    const matches = String(source || "").matchAll(regex);
    for (const match of matches) yield match;
}

export function indexOfAny(str: string, anyOf: any[], startIndex: number) {
    if (!str) return -1;
    if (!anyOf) return -1;
    let minIndex = -1;
    for (let j = 0; j < anyOf.length; j++) {
        let index = str.indexOf(anyOf[j], startIndex);
        if (index >= 0 && (minIndex === -1 || index < minIndex)) {
            minIndex = index;
        }
    }
    return minIndex;
};

export function findStringBetweenMatchingBrace(s: string, start: number, startBrace: string, endBrace: string) {
    const braces = [startBrace, endBrace];
    let pos = start;
    let end = start;
    let level = 0;
    let notStarted = true;
    while (true) {
        var index = indexOfAny(s, braces, pos);
        if (index < 0) break;
        if (notStarted) {
            notStarted = false;
            start = index + 1;
        }
        if (s[index] === startBrace) level++;
        if (s[index] === endBrace) level--;
        if (level <= 0) {
            end = index;
            break;
        }
        pos = index + 1;
    }
    return s.substring(start, end);
}

export function* getItemsFromString(source: string, itemSeparators: string[], separators: string[]) {
    const line = String(source || "");    
    let inString = false;
    let start = 0;
    for (var i = 0; i < line.length; i++) {
        const char = line[i];
        if (i + 1 === line.length) {
            yield line.substring(start, i + 1); // or slice()
        } else if (!inString && itemSeparators.includes(char)) {
            yield line.substring(start, i); // or slice()
            start = i + 1;
        } else if (separators.includes(char)) {
            inString = !inString;
        }
    }
}